import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import { Colors } from "../../constants/colors";
import { getLoggingConfig } from "../../services/logging";
async function fetchSessions() {
    const baseUrl = getLoggingConfig().serverUrl;
    const response = await fetch(`${baseUrl}/api/list_session_logs?offset=0&limit=100`);
    if (!response.ok) {
        throw new Error(`Failed to load session logs: ${response.status}`);
    }
    const payload = (await response.json());
    return payload.data?.logs || [];
}
function formatDateTime(value) {
    if (!value) {
        return "—";
    }
    const parsed = new Date(value);
    if (Number.isNaN(parsed.getTime())) {
        return value;
    }
    return parsed.toLocaleString();
}
export const SessionLogsTab = () => {
    const [sessions, setSessions] = React.useState([]);
    const [loading, setLoading] = React.useState(false);
    const [error, setError] = React.useState(null);
    const refresh = React.useCallback(async () => {
        setLoading(true);
        setError(null);
        try {
            const next = await fetchSessions();
            setSessions(next);
        }
        catch (err) {
            const message = err instanceof Error ? err.message : "Unknown error";
            setError(message);
        }
        finally {
            setLoading(false);
        }
    }, []);
    React.useEffect(() => {
        void refresh();
    }, [refresh]);
    return (_jsxs("div", { style: { height: "100%", display: "flex", flexDirection: "column", backgroundColor: Colors.MainBackground }, children: [_jsxs("div", { style: {
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    padding: "10px 12px",
                    borderBottom: `1px solid ${Colors.Gray300}`,
                }, children: [_jsx("div", { style: { fontSize: 13, fontWeight: 600, color: Colors.Gray900 }, children: "Session Logs" }), _jsx("button", { onClick: () => void refresh(), type: "button", style: {
                            border: `1px solid ${Colors.Gray300}`,
                            borderRadius: 6,
                            padding: "4px 10px",
                            background: Colors.MainBackground,
                            color: Colors.Gray800,
                            cursor: "pointer",
                            fontSize: 12,
                        }, disabled: loading, children: loading ? "Refreshing..." : "Refresh" })] }), _jsx("div", { style: { flex: 1, overflow: "auto", padding: 12 }, children: error ? (_jsx("div", { style: { color: Colors.Red60, fontSize: 12 }, children: error })) : sessions.length === 0 ? (_jsx("div", { style: { color: Colors.Gray700, fontSize: 12 }, children: loading ? "Loading session logs..." : "No session logs available." })) : (_jsx("div", { style: { display: "grid", gap: 8 }, children: sessions.map((session) => (_jsxs("div", { style: {
                            border: `1px solid ${Colors.Gray300}`,
                            borderRadius: 8,
                            padding: 10,
                            backgroundColor: Colors.MainBackground,
                        }, children: [_jsx("div", { style: { fontFamily: "monospace", fontSize: 11, color: Colors.Gray900, marginBottom: 6 }, children: session.sessionId }), _jsxs("div", { style: { fontSize: 12, color: Colors.Gray800 }, children: ["Host: ", session.host || "unknown"] }), _jsxs("div", { style: { fontSize: 12, color: Colors.Gray800 }, children: ["Document: ", session.documentName || session.presentationName || "Untitled"] }), _jsxs("div", { style: { fontSize: 12, color: Colors.Gray800 }, children: ["Started: ", formatDateTime(session.startedAt)] }), _jsxs("div", { style: { fontSize: 12, color: Colors.Gray800 }, children: ["Completed: ", formatDateTime(session.completedAt)] }), _jsxs("div", { style: { fontSize: 12, color: Colors.Gray800 }, children: ["Turns: ", session.totalTurns ?? 0, " | Errors: ", session.totalErrors ?? 0] })] }, session.sessionId))) })) })] }));
};
export default SessionLogsTab;
